import React from 'react'
import FormActions from '../system/forms/form-actions'
import StatusMessage from '../system/forms/status-message'
import LoadingButton, { ButtonStatus } from '../system/forms/loading-button'

const ContactFormActions = ({
  isValid,
  success,
  loading,
  error,
  called
}: {
  isValid: boolean
  success: boolean
  loading: boolean
  error: any
  called: boolean
}) => {
  let buttonStatus: ButtonStatus = 'initial'
  let statusMessage = ''
  if (loading) {
    buttonStatus = 'loading'
  } else if (error || (called && !success)) {
    buttonStatus = 'error'
    statusMessage = 'An unknown error occurred while submitting the response. Please try again.'
  } else if (called && success) {
    buttonStatus = 'success'
    statusMessage = `Thanks! Your submission has been recorded. We'll get in touch shortly.`
  }

  return (
    <FormActions>
      <StatusMessage>{statusMessage}</StatusMessage>

      <LoadingButton type="submit" status={buttonStatus} disabled={!isValid || (called && !error)}>
        Submit
      </LoadingButton>
    </FormActions>
  )
}

export default ContactFormActions
